const PROVIDERS = [
  {
    name: "OpenAI",
    svg: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5" aria-hidden="true">
        <path d="M22.28 9.98a5.83 5.83 0 0 0-.5-4.8 5.9 5.9 0 0 0-6.35-2.83A5.87 5.87 0 0 0 11 .54a5.9 5.9 0 0 0-5.62 4.1 5.87 5.87 0 0 0-3.92 2.85 5.9 5.9 0 0 0 .73 6.92 5.83 5.83 0 0 0 .5 4.8 5.9 5.9 0 0 0 6.35 2.83A5.87 5.87 0 0 0 13 23.46a5.9 5.9 0 0 0 5.63-4.1 5.87 5.87 0 0 0 3.91-2.85 5.9 5.9 0 0 0-.73-6.92zM13 21.87a4.37 4.37 0 0 1-2.8-1.02l.14-.08 4.65-2.68a.76.76 0 0 0 .38-.66v-6.55l1.97 1.13a.07.07 0 0 1 .04.05v5.42A4.41 4.41 0 0 1 13 21.87zm-9.38-4.04a4.37 4.37 0 0 1-.52-2.96l.14.08 4.65 2.69a.76.76 0 0 0 .76 0l5.68-3.28v2.27a.07.07 0 0 1-.03.06l-4.7 2.72a4.41 4.41 0 0 1-5.98-1.58zm-1.22-10.2A4.37 4.37 0 0 1 4.7 5.4v5.49a.76.76 0 0 0 .38.66l5.67 3.27-1.97 1.14a.07.07 0 0 1-.07 0L4 13.26a4.41 4.41 0 0 1-.6-5.62zM19.73 13l-5.68-3.28 1.97-1.13a.07.07 0 0 1 .07 0l4.7 2.72a4.4 4.4 0 0 1-.68 7.94v-5.6a.76.76 0 0 0-.38-.65zm1.96-3a6.6 6.6 0 0 0-.14-.09l-4.65-2.68a.76.76 0 0 0-.76 0L10.46 10.5V8.23a.07.07 0 0 1 .03-.06l4.7-2.71a4.4 4.4 0 0 1 6.5 4.56zM9.4 12.85 7.43 11.7a.07.07 0 0 1-.04-.06V6.24a4.4 4.4 0 0 1 7.22-3.38l-.14.08-4.65 2.68a.76.76 0 0 0-.38.66v6.56zm1.07-2.3 2.53-1.46 2.52 1.46v2.9l-2.52 1.46-2.53-1.46v-2.9z" />
      </svg>
    ),
  },
  {
    name: "Anthropic",
    svg: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5" aria-hidden="true">
        <path d="M13.827 3.52h3.603L24 20.48h-3.603l-6.57-16.96zm-7.258 0h3.767L16.906 20.48h-3.674l-1.343-3.461H5.017l-1.344 3.46H0L6.57 3.522zm4.132 10.959-2.17-5.62-2.17 5.62h4.34z" />
      </svg>
    ),
  },
  {
    name: "Azure OpenAI",
    svg: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5" aria-hidden="true">
        <path d="M13.05.4 5.99 8.735 0 19.602h6.307L13.05.4zM13.8 5.984l-4.09 11.527 7.884 1.42.001.001L24 19.603l-7.884-8.86-2.316-4.76z" />
      </svg>
    ),
  },
  {
    name: "Google",
    svg: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5" aria-hidden="true">
        <path d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z" />
      </svg>
    ),
  },
];

export default function LogoStrip() {
  return (
    <section className="border-y border-border/50 bg-bg-secondary/40 py-8">
      <div className="mx-auto max-w-7xl px-4 sm:px-5 md:px-8">
        <p className="mb-6 text-center text-xs font-semibold uppercase tracking-[0.16em] text-text-faint">
          Connect your preferred LLM provider — or route across multiple
        </p>
        <div className="flex flex-wrap items-center justify-center gap-8 sm:gap-12">
          {PROVIDERS.map((provider) => (
            <div
              key={provider.name}
              className="flex items-center gap-2 text-text-faint opacity-80 transition-all duration-200 hover:opacity-100 hover:text-text"
              title={provider.name}
            >
              {provider.svg}
              <span className="text-sm font-semibold">{provider.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
